// extracted by mini-css-extract-plugin
module.exports = {"root":"AmbassadorEdit_root__3diRV","textBreak":"AmbassadorEdit_textBreak__2Ol5p","title":"AmbassadorEdit_title__2GtM9","avatar":"AmbassadorEdit_avatar__2Qn99"};